/**
 * Minimal client-side CSV export (tag matter-economics, tasks #2275 / #2280).
 * No dependency - builds an RFC-4180-ish CSV and triggers a download.
 */

/** Escape a single CSV cell: wrap in quotes when it contains , " or newline. */
const escapeCell = (value: unknown): string => {
  const s = value === null || value === undefined ? '' : String(value);
  if (/[",\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

/** Serialize header + rows to a CSV string. */
export const toCsv = (headers: string[], rows: Array<Array<unknown>>): string => {
  const lines = [headers.map(escapeCell).join(',')];
  rows.forEach((row) => lines.push(row.map(escapeCell).join(',')));
  return lines.join('\r\n');
};

/** Build a CSV and trigger a browser download. */
export const downloadCsv = (filename: string, headers: string[], rows: Array<Array<unknown>>): void => {
  const csv = toCsv(headers, rows);
  // Prepend a BOM so Excel reads UTF-8 (currency symbols) correctly.
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
